export const SET_EMPLOYEES_TABLE_STATE = 'SET_EMPLOYEES_TABLE_STATE';
export const RESET_EMPLOYEES_TABLE_STATE = 'RESET_EMPLOYEES_TABLE_STATE';
export const SET_EMPLOYEES_SELECTED_ROWS = 'SET_EMPLOYEES_SELECTED_ROWS';

export const setEmployeesTableState = (queries: any) => ({
  type: SET_EMPLOYEES_TABLE_STATE,
  payload: queries,
});

export const resetEmployeesTableState = () => ({
  type: RESET_EMPLOYEES_TABLE_STATE,
});

export const setEmployeesSelectedRows = (selectedRows: any) => ({
  type: SET_EMPLOYEES_SELECTED_ROWS,
  payload: selectedRows,
});
